import { Component, Inject } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";
import { Tools } from "@app/util/tools";

@Component({
    selector: 'app-payment-error-dialog',
    template: require('./dialogPaymentError.html')
})
export class PaymentErrorDialog {

    constructor(@Inject(Tools) public tools: any,
                @Inject(MatDialogRef<PaymentErrorDialog>) public dialogRef: MatDialogRef<PaymentErrorDialog>) {}

    closeThisDialog(value: any) {
        this.dialogRef.close(value)
    }

}
